<div class="relative min-h-100">
  <ng-content></ng-content>
  @if (loading) {
    <div class="z-10 flex justify-center absolute inset-0 bg-white/75">
      <div class="fixed top-1/3">
        <mat-spinner></mat-spinner>
      </div>
      @if (message) {
        <p class="fixed top-1/2 text-18">{{message}}</p>
      }
    </div>
  }
</div>